import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Button } from 'react-bootstrap';

import { getCartSubscription } from '../../CartActions.js';
import { getUserGroup, getUserGroupOption } from '../../../User/UserGroupActions.js';
import { getConfig } from '../../../Config/ConfigActions.js';

import Icon from '../../../../components/Content/Icon.js';
import CmsPanel from '../../../Cms/components/content/CmsPanel.js';
import GamifiedButton from '../../../../components/Content/GamifiedButton.js';

// Subscription CTA for "pack" products: invites the user to turn the pack into a recurring
// subscription. Purely presentational + visibility guard; the parent owns how the pack is added
// to the cart and the subscription is activated (passed via onSubscribe).
function ProductSubscription({ product, variation = null, subscription = null, userGroup = null, isSubscriptionDisabled = false, onCart = false, onSubscribe = null, onUnSubscribe = null }) {
	if(onCart || isSubscriptionDisabled || !getUserGroupOption(userGroup, 'allowSubscription') || !(variation || product).isPack) {
		return null;
	}

	return (
		<div className={classNames('my-1 p-1 text-center text-sm-start bg-opacity-10 rounded text-sm', subscription?.isActive ? 'bg-success' : 'bg-danger')}>
			{
				subscription?.isActive
				? (
					<div className="p-2">
						<CmsPanel slug="product-subscription-addedto" />
						<Button variant="link" size="sm" className="p-0 mt-1 text-muted small text-decoration-none remove-subscription" onClick={onUnSubscribe}>
							<Icon icon="close" /> <FormattedMessage id="cartUnsubscribe" defaultMessage="Cancel my subscription" />
						</Button>

					</div>
				) : (
					<Row className="g-0 g-sm-2 ">
						<Col>
							<GamifiedButton as={Button} variant="outline-danger" size="sm" className="m-0 mt-lg-3 mt-xl-0 w-100" onClick={onSubscribe}><Icon icon="sync" /> <FormattedMessage id="cartAddTosubscription" defaultMessage="I subscribe to this pack" /></GamifiedButton>
						</Col>
						<Col xs="12" lg="8">
							<CmsPanel slug="product-subscription-addto" />
						</Col>
					</Row>
				)
			}
		</div>
	);
}

function mapStateToProps(store) {
	return {
		subscription: getCartSubscription(store),
		userGroup: getUserGroup(store),
		isSubscriptionDisabled: getConfig(store, 'is-subscription-disabled'),
	};
}

ProductSubscription.propTypes = {
	product: PropTypes.object.isRequired,
	variation: PropTypes.object,
	subscription: PropTypes.object,
	userGroup: PropTypes.object,
	isSubscriptionDisabled: PropTypes.bool,
	onCart: PropTypes.bool,
	onSubscribe: PropTypes.func,
	onUnSubscribe: PropTypes.func,
};

export default connect(mapStateToProps)(ProductSubscription);
